import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
Vue.use(VueResource)

import actions from '@/store/actions'
import mutations from './mutations'
import getters from './getters'

export default new Vuex.Store({
	state: {
		isLoggedIn: false,
		progress: {
			log: false,
			retreive: true,
		},
		errors: {
			login: {
				password: {
					indicator: false,
					message: []
				},
				email: {
					indicator: false,
					message: []
				},
				yandex: {
					indicator: false,
					message: []
				}
			}
		},
		currentReport: {},
		currentProject: {},
		userData: {
			meta: {
				favorites: [],
				theme: 'light'
			},
			notifications: [],
			notes: []
		},
		favObjects: [],
		recentObjects: [],
		headerSecondary: '',
		restrictedHeaders: {},
		breadcrumbs: [],
		sourceTypes: [],
		sourceTypeProviders: [],
		segments: [],
		verticals: [],
		brandingOption: document.location.hostname.includes('daskipper')? 'daskipper':'artics', // daskipper
		theme: {
			dark: {
				shadow: 'rgba(51, 51, 51, 0.5)',
				dialogHeader: 'grey darken-4'
			},
			light: {
				shadow: 'rgba(175,175,175,0.5)',
				dialogHeader: 'grey lighten-4'
			}
		},
		designVariant: {
			artics: {
				//logo: 'artics_num.png',
				logo: 'numbers.png',
				accentColor: '#C62828',
				accentColorIcon: 'red accent-4',
				upic: '@/assets/userpic_undefined_artics.png',
				email: 'press@artics.ru',
				titles: {
					main: 'Artics.Цифры',
					objects: 'В цифрах'
				}
			},
			daskipper: {
				logo: 'daskipper.png',
				accentColor: '#02274f',
				accentColorIcon: 'red accent-4',
				upic: '@/assets/userpic_undefined_daskipper.png',
				email: 'info@daskipper.com',
				titles: {
					main: 'Daskipper Digital',
					objects: 'Daskipper'
				}
			}
		},
		routing: {
			version: 'production',
			service: 'db-entities',
			project: 'trying-artics-pipeline',
			deploy: document.location.hostname != 'localhost'
		}
	},
	actions,
	mutations,
	getters,
	plugins: [
		createPersistedState({
			paths: ['isLoggedIn', 'userData.user', 'restrictedHeaders', 'userData.meta', 'recentObjects', 'currentProject', 'currentReport'],
			key: 'articsDigits'
		})
	]
});
